module.exports = __webpack_public_path__ + "static/media/traycorp17.621fb54c.png";